import React, { useState } from "react";
import { Form, Button, Input } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
   const [error, setError] = useState("");
     const handleRegister = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData);
    console.log(data);
    

    try {
      const response = await fetch(`${process.env.REACT_APP_API_LOGIN}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: data.name,
          email: data.email,
          password: data.password,
          phone_number: data.phone // match backend column
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Registration failed");
      }

      // success
      navigate("/login");
    } catch (err) {
      console.error("Register error:", err.message);
      setError(err.message);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-cover bg-admin_black">
      <div>
        <a href="/">
          <h1 className="text-3xl font-bold text-white dark:text-white mb-6">
            Matka
          </h1>
        </a>
      </div>

      <div className="w-full max-w-lg bg-white dark:bg-themedark-cardbg shadow-lg rounded-lg p-8 border border-gray-300">
        <div className="mb-6 ">
          <div className="py-6 text-2xl font-semibold">
            <h2>Sign Up</h2>
          </div>
          <Form
            className="w-full max-w-xl flex flex-col gap-6 px-3 py-4"
            onSubmit={handleRegister}
          >
            <Input
              isRequired
              errorMessage="Name"
              size="lg"
              label="Name"
              labelPlacement="outside"
              variant="bordered"
              name="name"
              placeholder="Enter your Name"
              type="text"
            />

            <Input
              isRequired
              errorMessage="Enter Email"
              size="lg"
              label="Email"
              labelPlacement="outside"
              variant="bordered"
              name="email"
              placeholder="Enter your email"
              type="email"
            />

            <Input
              isRequired
              errorMessage="Enter Password"
              label="Password"
              size="lg"
              labelPlacement="outside"
              variant="bordered"
              name="password"
              placeholder="Enter your password"
              type="password"
            />
            <Input
              isRequired
              errorMessage="Enter Phone Number"
              label="Phone"
              size="lg"
              labelPlacement="outside"
              variant="bordered"
              name="phone_number"
              placeholder="Enter your Phone Number"
              type="tel"
            />
            <div className="flex flex-col mt-2 w-full">
              <Button
                type="submit"
                className="w-full bg-admin_black text-white"
              >
                Register
              </Button>
              <div className="flex justify-center mt-2">
                <p>
                  Already have Account? <a href="/login" className="border-b border-admin_black hover:text-m_blue hover:border-b hover:border-m_blue px-1">Login</a>
                </p>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Register;
